'use client';

import VideoReactPlayer from '../components/VideoReactPlayer';
import { SCENARIOS_CLIPS } from '@/lib/clipConfigs';

export default function ScenariosPage() {
  return <VideoReactPlayer mode="scenarios" clips={SCENARIOS_CLIPS} />;
}
